module.exports = __webpack_public_path__ + "img/29@2x.e2f62586.png";